import React, { useEffect } from 'react';

import { Radio } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

type InputProps = {
  label: string;
  field: keyof EmployeeMergeResolutionType;
  existingDataValue: string | null;
  comparisonDataValue?: string | null;
  selectedValue?: string | null;
  updateField: (
    field: keyof EmployeeMergeResolutionType,
  ) => (e: React.ChangeEvent<HTMLInputElement>) => void;
  addDiscrepancy: (field: keyof EmployeeMergeResolutionType) => void;
};

const useStyles = makeStyles(() => ({
  cell: {
    height: 40,
    maxHeight: 40,
    paddingTop: 0,
    paddingBottom: 0,
  },
}));

export const DataComparisonRow = ({
  label,
  field,
  existingDataValue,
  comparisonDataValue,
  selectedValue,
  updateField,
  addDiscrepancy,
}: InputProps) => {
  const classes = useStyles();
  const hasDiscrepancy =
    existingDataValue && comparisonDataValue && comparisonDataValue !== existingDataValue;

  useEffect(() => {
    if (hasDiscrepancy && !selectedValue) {
      addDiscrepancy(field);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasDiscrepancy, selectedValue, comparisonDataValue]);

  if (!hasDiscrepancy) {
    return (
      <TableRow>
        <TableCell className={classes.cell}>
          <span className="typo-bold">{label}</span>
        </TableCell>
        <TableCell className={classes.cell}>{existingDataValue}</TableCell>
        <TableCell className={classes.cell}>{comparisonDataValue}</TableCell>
      </TableRow>
    );
  }

  return (
    <TableRow className={selectedValue ? '' : 'u-background-messageWarning'}>
      <TableCell className={classes.cell}>
        <span className="typo-bold">{label}</span>
      </TableCell>
      <TableCell className={classes.cell}>
        <Radio
          size="small"
          checked={selectedValue === existingDataValue}
          onChange={updateField(field)}
          value={existingDataValue}
        />
        {existingDataValue}
      </TableCell>
      <TableCell className={classes.cell}>
        <Radio
          size="small"
          checked={selectedValue === comparisonDataValue}
          onChange={updateField(field)}
          value={comparisonDataValue}
        />
        {comparisonDataValue}
      </TableCell>
    </TableRow>
  );
};
